import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment.prod';

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" })
};

@Injectable({
  providedIn: "root"
})
export class DocumentsService {
  baseUrl = environment.baseUrl;


  constructor(private http: HttpClient) { }

  submitDocuments(claimNumber: string, files: File[]): Observable<any> {
    const docOptions = { headers: new HttpHeaders({ "Accept": "application/json" }), params: { claimnumber: claimNumber.toString() } }
    const formData = new FormData();
    if (files && files.length) {
      files.forEach(file => formData.append('files', file));
    }
    return this.http.post<any>(this.baseUrl + "Correspondences/SubmitDocuments", formData, docOptions);
  }
}

